module.exports = {
  siteTitle: 'Margaux Chevreux - Développeuse mobile et web freelance', // <title>
  manifestName: 'Margaux Chevreux',
  manifestShortName: 'Margaux', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#101D31',
  manifestThemeColor: '#101D31',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/images/pic01.jpg',
  pathPrefix: `/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Margaux Chevreux',
  subHeading: "Développeuse d'applications mobiles et web sur mesure.",
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'github.com/Mgxcx',
      url: 'https://github.com/Mgxcx',
    },
    {
      icon: 'fa-twitter',
      name: 'twitter.com/Mgxcx',
      url: 'https://twitter.com/Mgxcx',
    },
    {
      icon: 'fa-linkedin',
      name: 'linkedin.com/in/margaux-chevreux',
      url: 'https://www.linkedin.com/in/margaux-chevreux-377586a4/',
    },
    {
      icon: 'fa-envelope-o',
      name: 'margaux.chevreux@mgxcx.fr',
      url: 'mailto:margaux.chevreux@mgxcx.fr',
    },
  ],
  phone: '+33 (0)6 49 08 54 53',
};
